import { Injectable, Inject } from '@angular/core';
import { RequirementChaserDO } from './RequirementChaser.model';

export class RequirementDO {

	public id: Number;

	public entityGuid: String = null;

	public clientId: Number = null;

	public requirementCd: String = null;

	public status: String = null;

	public statusCd: String = null

	public identifiedBy: String = null;

	public identifedDt: any = null;

	public requestedDt: any = null;

	public receivedDt: any = null;

	public reviewdBy: String = null;

	public reviewDt: any = null;

	public cancelledBy: String = null;

	public cancelDt: any = null;

	public waviedOffBy: String = null;

	public waviedOffDt: any = null;

	public submittedDocCd: String = null;

	public submittedDocUrl: String = null;

	public appliesToCd: String = null;

	public mandatoryFl: String = null;

	public requirementChaserList: RequirementChaserDO[] = [];

	/* Newly added props */
  public parentObject: any = null;
  public versionId: any = null;
  public createdDt: any = null;
  public updatedDt: any = null;
  public createdUser: any = null;
  public updatedUser: any = null;
  public baseCompanyCd: any = null;
  public errorFl: String = null;
  public warningFl: String = null;
  public exceptionDOList: any = null;
  public waviedOffReasonCd: any = null;
  public objectName: String = 'RequirementDO';
  public remarks: String = null;
  public resolveByStageCd: String = null;
  public clientRefGuid: any = null;
  public visibilityCd: any = null;
  public serviceCd: any = null;
  public referenceNum: any = null;
  public orderingNotes: any = null;
  public subTransactionGuid: any = null;


	public get $id(): Number {
		return this.id;
	}

	public set $id(value: Number) {
		this.id = value;
	}

	public get $entityGuid(): String {
		return this.entityGuid;
	}

	public set $entityGuid(value: String) {
		this.entityGuid = value;
	}

	public get $clientId(): Number {
		return this.clientId;
	}

	public set $clientId(value: Number) {
		this.clientId = value;
	}

	public get $requirementCd(): String {
		return this.requirementCd;
	}

	public set $requirementCd(value: String) {
		this.requirementCd = value;
	}

	public get $status(): String {
		return this.status;
	}

	public set $status(value: String) {
		this.status = value;
	}

	public get $identifiedBy(): String {
		return this.identifiedBy;
	}

	public set $identifiedBy(value: String) {
		this.identifiedBy = value;
	}

	public get $identifedDt(): Date {
		return this.identifedDt;
	}

	public set $identifedDt(value: Date) {
		this.identifedDt = value;
	}

	public get $requestedDt(): Date {
		return this.requestedDt;
	}

	public set $requestedDt(value: Date) {
		this.requestedDt = value;
	}

	public get $receivedDt(): Date {
		return this.receivedDt;
	}

	public set $receivedDt(value: Date) {
		this.receivedDt = value;
	}

	public get $reviewdBy(): String {
		return this.reviewdBy;
	}

	public set $reviewdBy(value: String) {
		this.reviewdBy = value;
	}

	public get $reviewDt(): Date {
		return this.reviewDt;
	}

	public set $reviewDt(value: Date) {
		this.reviewDt = value;
	}

	public get $cancelledBy(): String {
		return this.cancelledBy;
	}

	public set $cancelledBy(value: String) {
		this.cancelledBy = value;
	}

	public get $cancelDt(): Date {
		return this.cancelDt;
	}

	public set $cancelDt(value: Date) {
		this.cancelDt = value;
	}

	public get $waviedOffBy(): String {
		return this.waviedOffBy;
	}

	public set $waviedOffBy(value: String) {
		this.waviedOffBy = value;
	}

	public get $waviedOffDt(): Date {
		return this.waviedOffDt;
	}

	public set $waviedOffDt(value: Date) {
		this.waviedOffDt = value;
	}

	public get $submittedDocCd(): String {
		return this.submittedDocCd;
	}

	public set $submittedDocCd(value: String) {
		this.submittedDocCd = value;
	}

	public get $submittedDocUrl(): String {
		return this.submittedDocUrl;
	}

	public set $submittedDocUrl(value: String) {
		this.submittedDocUrl = value;
	}

	public get $appliesToCd(): String {
		return this.appliesToCd;
	}

	public set $appliesToCd(value: String) {
		this.appliesToCd = value;
	}

	public get $requirementChaserList(): RequirementChaserDO[] {
		return this.requirementChaserList;
	}

	public set $requirementChaserList(value: RequirementChaserDO[]) {
		this.requirementChaserList = value;
	}

}
